import { useBreakpoint } from "@brg/ui";
import { LayoutConst } from "core";
import { RefObject, useLayoutEffect, useMemo } from "react";

type UseScrollActiveTabIntoViewArgs = {
  activeIndexKey?: string;
  isLoading?: boolean;
  activeTabRef: RefObject<HTMLElement | null>;
  tabsKeys?: string[] | null;
  language?: string;
  forceMobile?: boolean;
};

export function useScrollActiveTabIntoView({
  activeIndexKey,
  isLoading,
  activeTabRef,
  tabsKeys,
  language,
  forceMobile,
}: UseScrollActiveTabIntoViewArgs) {
  const isMobile = !!forceMobile || useBreakpoint(LayoutConst.screen.s - 1);

  const tabsKeysSignature = useMemo(() => {
    if (!tabsKeys?.length) return "";
    return tabsKeys.join("|");
  }, [tabsKeys]);

  useLayoutEffect(() => {
    if (!isMobile) return;
    if (isLoading) return;
    if (!activeIndexKey) return;

    const tabEl = activeTabRef.current;
    if (!tabEl) return;

    const containerEl =
      (tabEl.closest?.(".slide-navigation-layout") as HTMLElement | null) ??
      (document.querySelector(".slide-navigation-layout") as HTMLElement | null);

    if (!containerEl) return;

    const scrollActiveIntoView = () => {
      const tabRect = tabEl.getBoundingClientRect();
      const containerRect = containerEl.getBoundingClientRect();

      const tabLeft = tabEl.offsetLeft;
      const tabRight = tabLeft + tabEl.offsetWidth;

      const visibleLeft = containerEl.scrollLeft;
      const visibleRight = visibleLeft + containerEl.clientWidth;

      if (tabLeft >= visibleLeft && tabRight <= visibleRight) return;

      if (tabRect.right > containerRect.right) {
        containerEl.scrollTo({
          left: tabLeft - containerEl.clientWidth + tabRect.width,
          behavior: "smooth",
        });
        return;
      }

      if (tabRect.left < containerRect.left) {
        containerEl.scrollTo({ left: tabLeft, behavior: "smooth" });
      }
    };

    // Два RAF, чтобы дождаться финальной раскладки на мобилке
    requestAnimationFrame(() => requestAnimationFrame(scrollActiveIntoView));
  }, [
    activeIndexKey,
    activeTabRef,
    isMobile,
    isLoading,
    language,
    tabsKeysSignature,
  ]);
}

import { useBreakpoint } from "@brg/ui";
import { LayoutConst } from "core";
import { RefObject, useLayoutEffect, useMemo } from "react";

type UseScrollActiveTabIntoViewArgs = {
  activeIndexKey?: string;
  isLoading?: boolean;
  activeTabRef: RefObject<HTMLElement | null>;
  tabsKeys?: string[] | null;
  language?: string;
  forceMobile?: boolean;
};

export function useScrollActiveTabIntoView({
  activeIndexKey,
  isLoading,
  activeTabRef,
  tabsKeys,
  language,
  forceMobile,
}: UseScrollActiveTabIntoViewArgs) {
  const isMobile = !!forceMobile || useBreakpoint(LayoutConst.screen.s - 1);

  const tabsKeysSignature = useMemo(() => {
    if (!tabsKeys?.length) return "";
    return tabsKeys.join("|");
  }, [tabsKeys]);

  useLayoutEffect(() => {
    if (!isMobile) return;
    if (isLoading) return;
    if (!activeIndexKey) return;

    const tabEl = activeTabRef.current;
    if (!tabEl) return;

    const containerEl =
      (tabEl.closest?.(".slide-navigation-layout") as HTMLElement | null) ??
      (document.querySelector(".slide-navigation-layout") as HTMLElement | null);

    if (!containerEl) return;

    const scrollActiveIntoView = () => {
      const tabRect = tabEl.getBoundingClientRect();
      const containerRect = containerEl.getBoundingClientRect();

      const tabLeft = tabEl.offsetLeft;
      const tabRight = tabLeft + tabEl.offsetWidth;

      const visibleLeft = containerEl.scrollLeft;
      const visibleRight = visibleLeft + containerEl.clientWidth;

      if (tabLeft >= visibleLeft && tabRight <= visibleRight) return;

      if (tabRect.right > containerRect.right) {
        containerEl.scrollTo({
          left: tabLeft - containerEl.clientWidth + tabRect.width,
          behavior: "smooth",
        });
        return;
      }

      if (tabRect.left < containerRect.left) {
        containerEl.scrollTo({ left: tabLeft, behavior: "smooth" });
      }
    };

    // Два RAF, чтобы дождаться финальной раскладки на мобилке
    requestAnimationFrame(() => requestAnimationFrame(scrollActiveIntoView));
  }, [
    activeIndexKey,
    activeTabRef,
    isMobile,
    isLoading,
    language,
    tabsKeysSignature,
  ]);
}

